// import React, { useState, useEffect, useCallback } from "react";
// import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
// import Footer from "../Footer/Footer";
// import { getReceipts } from "../Services/InvoiceReceiptService";
// import {
//   TextField,
//   Box,
//   Container,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
//   Stack,
//   Typography,
//   Chip,
//   IconButton,
//   Tooltip,
//   SelectChangeEvent,
//   Card,
//   CardContent,
//   Divider,
//   Skeleton,
//   Pagination,
//   useMediaQuery,
//   useTheme,
//   Collapse,
//   Button,
// } from "@mui/material";
// import ClearIcon      from "@mui/icons-material/Clear";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import ReceiptIcon    from "@mui/icons-material/Receipt";
// import {IReceipt} from "../Interfaces/IReceipt";

// // ── Types ─────────────────────────────────────────────────────────────────────

// const PAYMENT_MODES = ["CASH", "UPI", "BANK_TRANSFER", "CHEQUE","NET_BANKING","CREDIT"];

// const paymentChipColor = (mode: string) => {
//   switch (mode) {
//     case "CASH":          return "success";
//     case "UPI":           return "primary";
//     case "BANK_TRANSFER": return "info";
//     case "CHEQUE":        return "warning";
//     default:              return "default";
//   }
// };

// // ── Mobile Receipt Card ───────────────────────────────────────────────────────
// const ReceiptCard: React.FC<{ receipt: IReceipt }> = ({ receipt }) => (
//   <Card
//     variant="outlined"
//     sx={{
//       mb: 1.5,
//       borderRadius: 2,
//       "&:hover": { boxShadow: 3, borderColor: "primary.main" },
//       transition: "box-shadow 0.2s, border-color 0.2s",
//     }}
//   >
//     <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
//       {/* Row 1 — Customer + Amount */}
//       <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1}>
//         <Box>
//           <Typography variant="subtitle2" fontWeight={600} noWrap sx={{ maxWidth: 180 }}>
//             {receipt.customerName}
//           </Typography>
//          <Typography variant="body2" fontWeight={500}>
//           {receipt.referenceId || "—"}
//           </Typography>
//         </Box>
//         <Typography variant="subtitle1" fontWeight={700} color="primary.main">
//           ₹{Number(receipt.amount).toLocaleString("en-IN")}
//         </Typography>
//       </Stack>

//       <Divider sx={{ my: 1 }} />

//       {/* Row 2 — Reference ID + Payment Mode + Date */}
//       <Stack direction="row" justifyContent="space-between" alignItems="center">
//         <Box>
//           <Typography variant="caption" color="text.secondary">Reference</Typography>
//           <Typography variant="body2" fontWeight={500}>{receipt.referenceId || "—"}</Typography>
//         </Box>
//         {/* <Chip
//           label={receipt.paymentMode}
//           size="small"
//           color={paymentChipColor(receipt.paymentMode) as any}
//           variant="outlined"
//         /> */}
//         {receipt.paymentMode
//           ? <Chip label={receipt.paymentMode} size="small" color={paymentChipColor(receipt.paymentMode) as any} variant="outlined" />
//           : <Typography variant="body2" color="text.secondary">—</Typography>
//         }
//         <Box textAlign="right">
//           <Typography variant="caption" color="text.secondary">Date</Typography>
//           <Typography variant="body2">{receipt.createdDate}</Typography>
//         </Box>
//       </Stack>
//     </CardContent>
//   </Card>
// );

// // ── Mobile Skeleton ───────────────────────────────────────────────────────────
// const MobileSkeleton: React.FC = () => (
//   <>
//     {[1, 2, 3, 4, 5].map((i) => (
//       <Card key={i} variant="outlined" sx={{ mb: 1.5, borderRadius: 2 }}>
//         <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
//           <Stack direction="row" justifyContent="space-between" mb={1}>
//             <Box sx={{ flex: 1 }}>
//               <Skeleton width="60%" height={20} />
//               <Skeleton width="40%" height={16} />
//             </Box>
//             <Skeleton width={70} height={24} />
//           </Stack>
//           <Skeleton height={1} sx={{ my: 1 }} />
//           <Stack direction="row" justifyContent="space-between">
//             <Skeleton width="30%" height={36} />
//             <Skeleton width="25%" height={24} sx={{ borderRadius: 4 }} />
//             <Skeleton width="25%" height={36} />
//           </Stack>
//         </CardContent>
//       </Card>
//     ))}
//   </>
// );

// // ── Main Component ────────────────────────────────────────────────────────────
// const ViewReceipt: React.FC = () => {
//   const theme    = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.down("md"));

//   const orgId = localStorage.getItem("orgId") ?? "";

//   // ── State ───────────────────────────────────────────────────────────────────
//   const [allReceipts,  setAllReceipts]  = useState<IReceipt[]>([]); // full page from server
//   const [loading,      setLoading]      = useState(true);
//   const [totalRows,    setTotalRows]    = useState(0);
//   const [showFilters,  setShowFilters]  = useState(false);

//   // ── All filters are CLIENT-SIDE (applied on top of fetched page) ────────────
//   // Server only handles orgId + pagination
//   const [searchQuery,       setSearchQuery]       = useState(""); // receipt/ref ID search
//   const [filterCustomer,    setFilterCustomer]    = useState(""); // ✅ customer NAME filter
//   const [filterReferenceId, setFilterReferenceId] = useState(""); // ✅ reference ID filter
//   const [filterPaymentMode, setFilterPaymentMode] = useState(""); // ✅ payment mode filter

//   const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

//   // ── Fetch (server handles only orgId + page + limit) ───────────────────────
//   const fetchReceipts = useCallback(async () => {
//     if (!orgId) return;
//     try {
//       setLoading(true);
//       const data = await getReceipts(orgId, {
//         page:  paginationModel.page + 1,
//         limit: paginationModel.pageSize,
//       });

//       const formatted: IReceipt[] = (data.receipts ?? []).map((r: any) => ({
//         id:           r.receiptId,
//         receiptId:    r.receiptId,
//         referenceId:  r.referenceId  || "",
//         customerName: r.customerName || "—",
//         amount:       Number(r.amount ?? 0),
//         paymentMode:  r.paymentMode ? r.paymentMode.toUpperCase() : "",
//         createdDate:  r.createdDate?._seconds
//           ? new Date(r.createdDate._seconds * 1000).toLocaleDateString("en-IN")
//           : "—",
//       }));

//       setAllReceipts(formatted);
//       setTotalRows(
//         data.pagination
//           ? (data.pagination.page - 1) * data.pagination.limit + data.pagination.returned
//           : formatted.length
//       );
//     } catch (error) {
//       console.error("Failed to fetch receipts:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [orgId, paginationModel]); // ✅ no filter deps — filters are client-side only

//   useEffect(() => { fetchReceipts(); }, [fetchReceipts]);

//   // ── Client-side filter logic (all 4 filters applied together) ──────────────
//   const filteredReceipts = allReceipts.filter((r) => {
//     // 1. General search — matches receiptId or referenceId
//     if (searchQuery) {
//       const q = searchQuery.toLowerCase();
//       const matchesSearch =
//         r.receiptId.toLowerCase().includes(q) ||
//         r.referenceId.toLowerCase().includes(q);
//       if (!matchesSearch) return false;
//     }

//     // 2. Customer name filter (case-insensitive partial match)
//     if (filterCustomer) {
//       const matchesCustomer = r.customerName
//         .toLowerCase()
//         .includes(filterCustomer.toLowerCase());
//       if (!matchesCustomer) return false;
//     }

//     // 3. Reference ID filter (case-insensitive partial match)
//     if (filterReferenceId) {
//       const matchesRef = r.referenceId
//         .toLowerCase()
//         .includes(filterReferenceId.toLowerCase());
//       if (!matchesRef) return false;
//     }

//     // 4. Payment mode filter (exact match from dropdown)
//     if (filterPaymentMode && r.paymentMode !== filterPaymentMode) return false;

//     return true;
//   });

//   // ── Handlers ────────────────────────────────────────────────────────────────
//   const handleSelectChange =
//     (setter: (v: string) => void) => (e: SelectChangeEvent) => setter(e.target.value);

//   const clearFilters = () => {
//     setSearchQuery("");
//     setFilterCustomer("");
//     setFilterReferenceId("");
//     setFilterPaymentMode("");
//   };

//   const hasActiveFilters =
//     !!(searchQuery || filterCustomer || filterReferenceId || filterPaymentMode);

//   const activeFilterCount = [searchQuery, filterCustomer, filterReferenceId, filterPaymentMode]
//     .filter(Boolean).length;

//   // ── Desktop Columns ─────────────────────────────────────────────────────────
//   const columns: GridColDef[] = [
//     { field: "receiptId",    headerName: "Receipt ID",    flex: 1,   minWidth: 160 },
//     { field: "referenceId",  headerName: "Reference ID",  flex: 1,   minWidth: 160 }, // ✅ fix 1
//     { field: "customerName", headerName: "Customer Name", flex: 1.5, minWidth: 180 }, // ✅ fix 2
//     {
//       field: "amount",
//       headerName: "Paid Amount",
//       flex: 0.8,
//       minWidth: 120,
//       type: "number",
//       valueFormatter: (value: number) =>
//         `₹${Number(value ?? 0).toLocaleString("en-IN")}`,
//     },
//     {
//       field: "paymentMode",
//       headerName: "Payment Mode",
//       flex: 0.8,
//       minWidth: 130,
//       renderCell: (params: GridRenderCellParams) =>
//       params.value ? (
//         <Chip label={params.value} size="small" color={paymentChipColor(params.value) as any} variant="outlined" />
//       ) : (
//         <Typography variant="body2" color="text.secondary">—</Typography>
//       ),
//     },
//     { field: "createdDate", headerName: "Receipt Date", flex: 0.8, minWidth: 120 },
//   ];

//   // ── Render ──────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <div className="page-location">
//         <span>Receipt &gt; View Receipts</span>
//       </div>

//       <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 3 }, py: 1 }}>

//         {/* ── Header ───────────────────────────────────────────────────────── */}
//         <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
//           <Stack direction="row" alignItems="center" spacing={1}>
//             <ReceiptIcon color="primary" fontSize={isMobile ? "small" : "medium"} />
//             <Typography variant={isMobile ? "subtitle1" : "h6"} fontWeight={600}>
//               Receipts
//               {totalRows > 0 && (
//                 <Typography component="span" variant="body2" color="text.secondary" ml={1}>
//                   ({filteredReceipts.length} of {totalRows})
//                 </Typography>
//               )}
//             </Typography>
//           </Stack>

//           <Button
//             size="small"
//             startIcon={<FilterListIcon />}
//             variant={hasActiveFilters ? "contained" : "outlined"}
//             onClick={() => setShowFilters((v) => !v)}
//             color={hasActiveFilters ? "primary" : "inherit"}
//           >
//             {isMobile
//               ? `Filters${activeFilterCount > 0 ? ` (${activeFilterCount})` : ""}`
//               : showFilters ? "Hide Filters" : "Show Filters"}
//           </Button>
//         </Stack>

//         {/* ── Filter Panel ─────────────────────────────────────────────────── */}
//         <Collapse in={showFilters}>
//           <Box
//             mb={2}
//             p={isMobile ? 1.5 : 2}
//             sx={{
//               bgcolor: "grey.50",
//               borderRadius: 2,
//               border: "1px solid",
//               borderColor: "grey.200",
//             }}
//           >
//             <Stack
//               direction={{ xs: "column", sm: "row" }}
//               spacing={1.5}
//               flexWrap="wrap"
//               useFlexGap
//             >
//               {/* 1. Receipt / Reference search */}
//               <TextField
//                 label="Search"
//                 placeholder="Receipt ID or Reference ID"
//                 variant="outlined"
//                 size="small"
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 fullWidth={isMobile}
//                 sx={{ flex: { sm: "1 1 200px" } }}
//               />

//               {/* 2. Customer Name filter ✅ fix 2 */}
//               <TextField
//                 label="Customer Name"
//                 variant="outlined"
//                 size="small"
//                 value={filterCustomer}
//                 onChange={(e) => setFilterCustomer(e.target.value)}
//                 fullWidth={isMobile}
//                 sx={{ flex: { sm: "1 1 180px" } }}
//               />

//               {/* 3. Reference ID filter ✅ fix 1 */}
//               <TextField
//                 label="Reference ID"
//                 variant="outlined"
//                 size="small"
//                 value={filterReferenceId}
//                 onChange={(e) => setFilterReferenceId(e.target.value)}
//                 fullWidth={isMobile}
//                 sx={{ flex: { sm: "1 1 160px" } }}
//               />

//               {/* 4. Payment Mode ✅ fix 3 */}
//               <FormControl
//                 size="small"
//                 fullWidth={isMobile}
//                 sx={{ flex: { sm: "1 1 150px" } }}
//               >
//                 <InputLabel>Payment Mode</InputLabel>
//                 <Select
//                   value={filterPaymentMode}
//                   label="Payment Mode"
//                   onChange={handleSelectChange(setFilterPaymentMode)}
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   {PAYMENT_MODES.map((mode) => (
//                     <MenuItem key={mode} value={mode}>{mode}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               {hasActiveFilters && (
//                 <Tooltip title="Clear all filters">
//                   <IconButton
//                     onClick={clearFilters}
//                     size="small"
//                     color="error"
//                     sx={{ alignSelf: { xs: "flex-end", sm: "center" } }}
//                   >
//                     <ClearIcon />
//                   </IconButton>
//                 </Tooltip>
//               )}
//             </Stack>

//             {/* Active filter chips */}
//             {hasActiveFilters && (
//               <Stack direction="row" spacing={0.5} mt={1.5} flexWrap="wrap" useFlexGap>
//                 <Typography variant="caption" color="text.secondary" sx={{ alignSelf: "center" }}>
//                   Active:
//                 </Typography>
//                 {searchQuery       && <Chip label={`Search: "${searchQuery}"`}           size="small" onDelete={() => setSearchQuery("")}       />}
//                 {filterCustomer    && <Chip label={`Customer: ${filterCustomer}`}         size="small" onDelete={() => setFilterCustomer("")}    />}
//                 {filterReferenceId && <Chip label={`Reference: ${filterReferenceId}`}     size="small" onDelete={() => setFilterReferenceId("")} />}
//                 {filterPaymentMode && <Chip label={`Mode: ${filterPaymentMode}`}          size="small" onDelete={() => setFilterPaymentMode("")} />}
//               </Stack>
//             )}
//           </Box>
//         </Collapse>

//         {/* ── Mobile: Card List ─────────────────────────────────────────────── */}
//         {isMobile ? (
//           <>
//             {loading ? (
//               <MobileSkeleton />
//             ) : filteredReceipts.length === 0 ? (
//               <Box textAlign="center" py={6}>
//                 <ReceiptIcon sx={{ fontSize: 48, color: "grey.300", mb: 1 }} />
//                 <Typography color="text.secondary">No receipts found</Typography>
//                 {hasActiveFilters && (
//                   <Button size="small" onClick={clearFilters} sx={{ mt: 1 }}>
//                     Clear filters
//                   </Button>
//                 )}
//               </Box>
//             ) : (
//               <>
//                 {filteredReceipts.map((receipt) => (
//                   <ReceiptCard key={receipt.receiptId} receipt={receipt} />
//                 ))}
//                 <Stack alignItems="center" spacing={1} mt={2} mb={1}>
//                   <Pagination
//                     count={Math.ceil(totalRows / paginationModel.pageSize)}
//                     page={paginationModel.page + 1}
//                     onChange={(_, newPage) =>
//                       setPaginationModel((prev) => ({ ...prev, page: newPage - 1 }))
//                     }
//                     color="primary"
//                     size="small"
//                     siblingCount={1}
//                   />
//                   <Typography variant="caption" color="text.secondary">
//                     Showing {filteredReceipts.length} of {totalRows} receipts
//                   </Typography>
//                 </Stack>
//               </>
//             )}
//           </>
//         ) : (
//           /* ── Tablet / Desktop: DataGrid ──────────────────────────────────── */
//           <DataGrid
//             rows={filteredReceipts}
//             columns={columns}
//             getRowId={(row) => row.receiptId}
//             loading={loading}
//             pagination
//             paginationMode="server"
//             rowCount={totalRows}
//             paginationModel={paginationModel}
//             onPaginationModelChange={setPaginationModel}
//             pageSizeOptions={[10, 25, 100]}
//             autoHeight
//             disableRowSelectionOnClick
//             sx={{
//               borderRadius: 2,
//               "& .MuiDataGrid-columnHeaders": { bgcolor: "grey.50", fontWeight: 600 },
//               ...(isTablet && {
//                 "& .MuiDataGrid-cell[data-field='referenceId']":         { display: "none" },
//                 "& .MuiDataGrid-columnHeader[data-field='referenceId']": { display: "none" },
//               }),
//             }}
//           />
//         )}
//       </Container>

//       <Box sx={{ width: "100%", mt: isMobile ? 4 : 10 }}>
//         <Footer />
//       </Box>
//     </>
//   );
// };

// export default ViewReceipt;

import React, { useState, useEffect, useCallback } from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import Footer from "../Footer/Footer";
import { getReceipts } from "../Services/InvoiceReceiptService";
import {
  TextField,
  Box,
  Container,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stack,
  Typography,
  Chip,
  IconButton,
  Tooltip,
  SelectChangeEvent,
  Card,
  CardContent,
  Divider,
  Skeleton,
  Pagination,
  useMediaQuery,
  useTheme,
  Collapse,
  Button,
  Alert,
} from "@mui/material";
import ClearIcon       from "@mui/icons-material/Clear";
import FilterListIcon  from "@mui/icons-material/FilterList";
import ReceiptIcon     from "@mui/icons-material/Receipt";
import { IReceipt }   from "../Interfaces/IReceipt";
 
// ─── Constants ────────────────────────────────────────────────────────────────
 
const PAYMENT_MODES = ["CASH", "UPI", "BANK_TRANSFER", "CHEQUE", "NET_BANKING", "CREDIT"];
 
const paymentChipColor = (mode: string) => {
  switch (mode?.toUpperCase()) {
    case "CASH":          return "success";
    case "UPI":           return "primary";
    case "BANK_TRANSFER": return "info";
    case "CHEQUE":        return "warning";
    case "NET_BANKING":   return "secondary";
    case "CREDIT":        return "error";
    default:              return "default";
  }
};
 
// ─── Mobile Receipt Card ──────────────────────────────────────────────────────
 
const ReceiptCard: React.FC<{ receipt: IReceipt }> = ({ receipt }) => (
  <Card
    variant="outlined"
    sx={{
      mb: 1.5, borderRadius: 2,
      "&:hover": { boxShadow: 3, borderColor: "primary.main" },
      transition: "box-shadow 0.2s, border-color 0.2s",
    }}
  >
    <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1}>
        <Box>
          <Typography variant="subtitle2" fontWeight={600} noWrap sx={{ maxWidth: 180 }}>
            {receipt.customerName}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {receipt.receiptId}
          </Typography>
        </Box>
        <Typography variant="subtitle1" fontWeight={700} color="primary.main">
          ₹{Number(receipt.amount).toLocaleString("en-IN")}
        </Typography>
      </Stack>
 
      <Divider sx={{ my: 1 }} />
 
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="caption" color="text.secondary">Reference</Typography>
          <Typography variant="body2" fontWeight={500}>{receipt.referenceId || "—"}</Typography>
        </Box>
        {receipt.paymentMode
          ? <Chip label={receipt.paymentMode} size="small"
              color={paymentChipColor(receipt.paymentMode) as any} variant="outlined" />
          : <Typography variant="body2" color="text.secondary">—</Typography>
        }
        <Box textAlign="right">
          <Typography variant="caption" color="text.secondary">Date</Typography>
          <Typography variant="body2">{receipt.createdDate}</Typography>
        </Box>
      </Stack>
    </CardContent>
  </Card>
);
 
// ─── Mobile Skeleton ──────────────────────────────────────────────────────────
 
const MobileSkeleton: React.FC = () => (
  <>
    {[1, 2, 3, 4, 5].map((i) => (
      <Card key={i} variant="outlined" sx={{ mb: 1.5, borderRadius: 2 }}>
        <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
          <Stack direction="row" justifyContent="space-between" mb={1}>
            <Box sx={{ flex: 1 }}>
              <Skeleton width="60%" height={20} />
              <Skeleton width="40%" height={16} />
            </Box>
            <Skeleton width={70} height={24} />
          </Stack>
          <Skeleton height={1} sx={{ my: 1 }} />
          <Stack direction="row" justifyContent="space-between">
            <Skeleton width="30%" height={36} />
            <Skeleton width="25%" height={24} sx={{ borderRadius: 4 }} />
            <Skeleton width="25%" height={36} />
          </Stack>
        </CardContent>
      </Card>
    ))}
  </>
);
 
// ─── Main Component ───────────────────────────────────────────────────────────
 
const ViewReceipt: React.FC = () => {
  const theme    = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
 
  const orgId = localStorage.getItem("orgId") ?? "";
 
  // ── Data state ────────────────────────────────────────────────────────────
  const [allReceipts, setAllReceipts] = useState<IReceipt[]>([]);
  const [loading,     setLoading]     = useState(true);
  const [fetchError,  setFetchError]  = useState("");
 
  /**
   * totalRows — the TRUE server-side count of all matching records.
   * This is what tells DataGrid and mobile Pagination how many pages exist.
   *
   * We initialise to -1 (unknown). Once we get a `total` from the backend,
   * we use it. If the backend doesn't send `total` yet, we use the
   * hasMore fallback: set totalRows to (page * limit + 1) when the server
   * returned a full page (meaning there might be more).
   */
  const [totalRows, setTotalRows] = useState<number>(-1);  // -1 = unknown
 
  // ── Pagination ────────────────────────────────────────────────────────────
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
 
  // ── Filters (client-side, applied on fetched page) ────────────────────────
  const [showFilters,       setShowFilters]       = useState(false);
  const [searchQuery,       setSearchQuery]       = useState("");
  const [filterCustomer,    setFilterCustomer]    = useState("");
  const [filterReferenceId, setFilterReferenceId] = useState("");
  const [filterPaymentMode, setFilterPaymentMode] = useState("");
 
  // ── Fetch ─────────────────────────────────────────────────────────────────
  const fetchReceipts = useCallback(async () => {
    if (!orgId) return;
    setLoading(true);
    setFetchError("");
    try {
      const data = await getReceipts(orgId, {
        page:  paginationModel.page + 1,   // server is 1-based
        limit: paginationModel.pageSize,
      });
 
      const receipts: IReceipt[] = (data.receipts ?? []).map((r: any) => ({
        id:           r.receiptId,
        receiptId:    r.receiptId,
        referenceId:  r.referenceId  || "",
        customerName: r.customerName || "—",
        amount:       Number(r.amount ?? 0),
        paymentMode:  r.paymentMode ? r.paymentMode.toUpperCase() : "",
        createdDate:  r.createdDate?._seconds
          ? new Date(r.createdDate._seconds * 1000).toLocaleDateString("en-IN")
          : typeof r.createdDate === "string"
            ? r.createdDate
            : "—",
      }));
 
      setAllReceipts(receipts);
 
      // ── FIX: Correctly derive totalRows ────────────────────────────────
      const pagination = data.pagination ?? {};
      const returned   = pagination.returned ?? receipts.length;
      const limit      = pagination.limit    ?? paginationModel.pageSize;
      const page       = pagination.page     ?? paginationModel.page + 1;
 
      if (typeof pagination.total === "number") {
        // ✅ Best case: backend sends the real total count
        setTotalRows(pagination.total);
      } else {
        // Fallback: if returned a full page, assume at least one more exists
        // This makes DataGrid show the Next button even without a total count.
        const knownMin = (page - 1) * limit + returned;
        const hasMore  = returned === limit;
        setTotalRows(hasMore ? knownMin + 1 : knownMin);
        // knownMin + 1 makes DataGrid think there might be a next page.
        // When the user goes to the last real page and gets < limit results,
        // we set exact count and the Next button disappears correctly.
      }
    } catch (err: any) {
      console.error("Failed to fetch receipts:", err);
      setFetchError(err?.message || "Failed to load receipts. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [orgId, paginationModel]); // ← paginationModel in deps so page/size changes trigger fetch
 
  // ── Re-fetch whenever page or pageSize changes ────────────────────────────
  useEffect(() => { fetchReceipts(); }, [fetchReceipts]);
 
  // ── Client-side filter (on current fetched page only) ────────────────────
  const filteredReceipts = allReceipts.filter((r) => {
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      if (
        !r.receiptId.toLowerCase().includes(q) &&
        !r.referenceId.toLowerCase().includes(q)
      ) return false;
    }
    if (filterCustomer && !r.customerName.toLowerCase().includes(filterCustomer.toLowerCase()))
      return false;
    if (filterReferenceId && !r.referenceId.toLowerCase().includes(filterReferenceId.toLowerCase()))
      return false;
    if (filterPaymentMode && r.paymentMode !== filterPaymentMode)
      return false;
    return true;
  });
 
  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleSelectChange =
    (setter: (v: string) => void) => (e: SelectChangeEvent) => setter(e.target.value);
 
  const clearFilters = () => {
    setSearchQuery("");
    setFilterCustomer("");
    setFilterReferenceId("");
    setFilterPaymentMode("");
  };
 
  const hasActiveFilters =
    !!(searchQuery || filterCustomer || filterReferenceId || filterPaymentMode);
 
  const activeFilterCount = [searchQuery, filterCustomer, filterReferenceId, filterPaymentMode]
    .filter(Boolean).length;
 
  // ── Desktop Columns ───────────────────────────────────────────────────────
  const columns: GridColDef[] = [
    { field: "receiptId",    headerName: "Receipt ID",    flex: 1,   minWidth: 150 },
    { field: "referenceId",  headerName: "Reference ID",  flex: 1,   minWidth: 150 },
    { field: "customerName", headerName: "Customer Name", flex: 1.5, minWidth: 180 },
    {
      field:          "amount",
      headerName:     "Paid Amount",
      flex:           0.8,
      minWidth:       120,
      type:           "number",
      valueFormatter: (value: number) =>
        `₹${Number(value ?? 0).toLocaleString("en-IN")}`,
    },
    {
      field:      "paymentMode",
      headerName: "Payment Mode",
      flex:       0.8,
      minWidth:   130,
      renderCell: (params: GridRenderCellParams) =>
        params.value ? (
          <Chip
            label={params.value}
            size="small"
            color={paymentChipColor(params.value) as any}
            variant="outlined"
          />
        ) : (
          <Typography variant="body2" color="text.secondary">—</Typography>
        ),
    },
    { field: "createdDate", headerName: "Receipt Date", flex: 0.8, minWidth: 120 },
  ];
 
  // ── Compute total page count for mobile Pagination ────────────────────────
  // Use totalRows if known; otherwise use fetched page count as minimum
  const totalPages = totalRows > 0
    ? Math.ceil(totalRows / paginationModel.pageSize)
    : paginationModel.page + 1;    // at minimum, current page exists
 
  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <>
      <div className="page-location">
        <span>Receipt &gt; View Receipts</span>
      </div>
 
      <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 3 }, py: 1 }}>
 
        {/* ── Header ────────────────────────────────────────────────────── */}
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <ReceiptIcon color="primary" fontSize={isMobile ? "small" : "medium"} />
            <Typography variant={isMobile ? "subtitle1" : "h6"} fontWeight={600}>
              Receipts
              {totalRows > 0 && (
                <Typography component="span" variant="body2" color="text.secondary" ml={1}>
                  ({filteredReceipts.length} shown
                  {hasActiveFilters ? " after filter" : ""} · {totalRows} total)
                </Typography>
              )}
            </Typography>
          </Stack>
 
          <Button
            size="small"
            startIcon={<FilterListIcon />}
            variant={hasActiveFilters ? "contained" : "outlined"}
            onClick={() => setShowFilters((v) => !v)}
            color={hasActiveFilters ? "primary" : "inherit"}
          >
            {isMobile
              ? `Filters${activeFilterCount > 0 ? ` (${activeFilterCount})` : ""}`
              : showFilters ? "Hide Filters" : "Show Filters"}
          </Button>
        </Stack>
 
        {/* ── Error ─────────────────────────────────────────────────────── */}
        {fetchError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setFetchError("")}>
            {fetchError}
          </Alert>
        )}
 
        {/* ── Filter Note (client-side notice) ──────────────────────────── */}
        {hasActiveFilters && (
          <Alert severity="info" sx={{ mb: 1.5 }} icon={false}>
            Filters apply to the <strong>current page</strong> only.
            Use pagination to browse other pages.
          </Alert>
        )}
 
        {/* ── Filter Panel ──────────────────────────────────────────────── */}
        <Collapse in={showFilters}>
          <Box
            mb={2} p={isMobile ? 1.5 : 2}
            sx={{
              bgcolor: "grey.50", borderRadius: 2,
              border: "1px solid", borderColor: "grey.200",
            }}
          >
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} flexWrap="wrap" useFlexGap>
 
              {/* Search — receipt ID or ref ID */}
              <TextField
                label="Search"
                placeholder="Receipt ID or Reference ID"
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                fullWidth={isMobile}
                sx={{ flex: { sm: "1 1 200px" } }}
              />
 
              {/* Customer name */}
              <TextField
                label="Customer Name"
                size="small"
                value={filterCustomer}
                onChange={(e) => setFilterCustomer(e.target.value)}
                fullWidth={isMobile}
                sx={{ flex: { sm: "1 1 180px" } }}
              />
 
              {/* Reference ID */}
              <TextField
                label="Reference ID"
                size="small"
                value={filterReferenceId}
                onChange={(e) => setFilterReferenceId(e.target.value)}
                fullWidth={isMobile}
                sx={{ flex: { sm: "1 1 160px" } }}
              />
 
              {/* Payment Mode */}
              <FormControl size="small" fullWidth={isMobile} sx={{ flex: { sm: "1 1 150px" } }}>
                <InputLabel>Payment Mode</InputLabel>
                <Select
                  value={filterPaymentMode}
                  label="Payment Mode"
                  onChange={handleSelectChange(setFilterPaymentMode)}
                >
                  <MenuItem value="">All</MenuItem>
                  {PAYMENT_MODES.map((mode) => (
                    <MenuItem key={mode} value={mode}>{mode}</MenuItem>
                  ))}
                </Select>
              </FormControl>
 
              {hasActiveFilters && (
                <Tooltip title="Clear all filters">
                  <IconButton
                    onClick={clearFilters}
                    size="small"
                    color="error"
                    sx={{ alignSelf: { xs: "flex-end", sm: "center" } }}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
 
            {/* Active filter chips */}
            {hasActiveFilters && (
              <Stack direction="row" spacing={0.5} mt={1.5} flexWrap="wrap" useFlexGap>
                <Typography variant="caption" color="text.secondary" sx={{ alignSelf: "center" }}>
                  Active:
                </Typography>
                {searchQuery       && <Chip label={`Search: "${searchQuery}"`}       size="small" onDelete={() => setSearchQuery("")}       />}
                {filterCustomer    && <Chip label={`Customer: ${filterCustomer}`}     size="small" onDelete={() => setFilterCustomer("")}    />}
                {filterReferenceId && <Chip label={`Ref: ${filterReferenceId}`}       size="small" onDelete={() => setFilterReferenceId("")} />}
                {filterPaymentMode && <Chip label={`Mode: ${filterPaymentMode}`}      size="small" onDelete={() => setFilterPaymentMode("")} />}
              </Stack>
            )}
          </Box>
        </Collapse>
 
        {/* ── Mobile: Card List + Pagination ────────────────────────────── */}
        {isMobile ? (
          <>
            {loading ? (
              <MobileSkeleton />
            ) : filteredReceipts.length === 0 ? (
              <Box textAlign="center" py={6}>
                <ReceiptIcon sx={{ fontSize: 48, color: "grey.300", mb: 1 }} />
                <Typography color="text.secondary">No receipts found</Typography>
                {hasActiveFilters && (
                  <Button size="small" onClick={clearFilters} sx={{ mt: 1 }}>
                    Clear filters
                  </Button>
                )}
              </Box>
            ) : (
              <>
                {filteredReceipts.map((r) => (
                  <ReceiptCard key={r.receiptId} receipt={r} />
                ))}
 
                {/* ── FIX: Mobile pagination ── */}
                <Stack alignItems="center" spacing={1} mt={2} mb={1}>
                  <Pagination
                    count={totalPages}
                    page={paginationModel.page + 1}
                    onChange={(_, newPage) => {
                      // Scroll to top when page changes
                      window.scrollTo({ top: 0, behavior: "smooth" });
                      setPaginationModel((prev) => ({ ...prev, page: newPage - 1 }));
                    }}
                    color="primary"
                    size="small"
                    siblingCount={1}
                    // Show Next even on last "known" page when total is uncertain
                    showFirstButton
                    showLastButton={totalRows > 0}
                  />
                  <Typography variant="caption" color="text.secondary">
                    Page {paginationModel.page + 1}
                    {totalRows > 0
                      ? ` of ${totalPages} · ${totalRows} total receipts`
                      : ` · ${filteredReceipts.length} shown`}
                  </Typography>
                </Stack>
              </>
            )}
          </>
        ) : (
          /* ── Tablet / Desktop: DataGrid ───────────────────────────────── */
          <DataGrid
            rows={filteredReceipts}
            columns={columns}
            getRowId={(row) => row.receiptId}
            loading={loading}
 
            // ── FIX: Server-side pagination ──
            pagination
            paginationMode="server"
            rowCount={totalRows === -1 ? 0 : totalRows}  // 0 shows loading indicator
            paginationModel={paginationModel}
            onPaginationModelChange={(model) => {
              // Scroll to top on page change
              window.scrollTo({ top: 0, behavior: "smooth" });
              setPaginationModel(model);
            }}
            pageSizeOptions={[10, 25, 50, 100]}
 
            autoHeight
            disableRowSelectionOnClick
            density="compact"
 
            // Show "No rows" message
            slots={{
              noRowsOverlay: () => (
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%" py={4}>
                  <ReceiptIcon sx={{ fontSize: 48, color: "grey.300", mb: 1 }} />
                  <Typography color="text.secondary">No receipts found</Typography>
                  {hasActiveFilters && (
                    <Button size="small" onClick={clearFilters} sx={{ mt: 1 }}>
                      Clear filters
                    </Button>
                  )}
                </Box>
              ),
            }}
 
            sx={{
              borderRadius: 2,
              "& .MuiDataGrid-columnHeaders":          { bgcolor: "grey.50", fontWeight: 600 },
              "& .MuiDataGrid-footerContainer":        { borderTop: "1px solid", borderColor: "divider" },
              // Hide Reference ID column on tablet to save space
              ...(isTablet && {
                "& .MuiDataGrid-cell[data-field='referenceId']":         { display: "none" },
                "& .MuiDataGrid-columnHeader[data-field='referenceId']": { display: "none" },
              }),
            }}
          />
        )}
      </Container>
 
      <Box sx={{ width: "100%", mt: isMobile ? 4 : 10 }}>
        <Footer />
      </Box>
    </>
  );
};
 
export default ViewReceipt;
 